import { MobilityContactCardInterface } from "./mobility-contact-card-interface";

export enum UserPermission {
  AdminDivision = "AdminDivision",
  AdminDelegation = "AdminDelegation",
  User = "User",
}

export interface DetailedUserInterface {
  delegation: string;
  division: string;
  firstName: string;
  lastName: string;
  job: string;
  photoUrl?: string;
  contacts?: MobilityContactCardInterface[];
  permission?: UserPermission;
}
